import React from 'react';

import {Button, CheckIcon, ModalPopup} from '@kit';

import {useCharacter} from '../../../character-context';
import {formatDice, parseDice} from '../../../model/dice';
import {healedHitPoints, resourceKey} from '../../../model/procedures';
import {useRoll} from '../../dice-roller';
import {useFeatureAction} from '../use-feature-action';
import type {ProcedureModalProps} from './procedure-modal-props';

import css from '../../sheet.module.css';

/** возврат очков ресурса: Восстановление чар, Феноменальный метаболизм с броском лечения */
export const ResourceRecoveryModal: React.FC<ProcedureModalProps<'resourceRecovery'>> = ({
	action,
	procedure,
	onClose,
}) => {
	const {character, update} = useCharacter();
	const {spend, canUse} = useFeatureAction(action);
	const roll = useRoll();
	const key = resourceKey(procedure.resource);
	const pool = character.limitedUse(key);
	const spent = pool?.spent || 0;
	const restored = Math.min(spent, procedure.amount ?? spent);
	const healing = procedure.healing ? parseDice(procedure.healing) : undefined;

	const recover = () => {
		spend(`${pool?.title || 'Ресурс'}: +${restored}`, (current) => ({
			spentUses: {...current.spentUses, [key]: Math.max(0, (current.spentUses[key] || 0) - restored)},
		}));
		if (healing) {
			roll({
				title: `${action.title}: лечение`,
				formula: healing,
				onTotal: (total) => update((current) => ({hitPoints: healedHitPoints(current.hitPoints, total)})),
			});
		}
		onClose();
	};

	return (
		<ModalPopup open onClose={onClose} header={action.title} maxWidth={480}>
			<p>
				{pool?.title}: потрачено {spent} из {pool?.max ?? 0}, вернётся <b>{restored}</b>.
			</p>
			{healing && <p className={css.muted}>Вместе с этим вы восстановите ПЗ: {formatDice(healing)}.</p>}
			<div className={css.modalButtons}>
				<Button appearance="secondary" onClick={onClose}>
					Отмена
				</Button>
				<Button
					appearance="primary"
					icon={<CheckIcon />}
					disabled={!canUse || (!restored && !healing)}
					onClick={recover}
				>
					Восстановить
				</Button>
			</div>
		</ModalPopup>
	);
};
